import { useUnit } from 'effector-react'
import { $contest, $params, $participants, $total, getParticipantsFx, paramsChanged, refresh } from './model'
export const usePartnerContest = () => useUnit({ contest: $contest, participants: $participants, total: $total, params: $params, loading: getParticipantsFx.pending, paramsChanged, refresh })
